import type {
  DriverAssignment,
  DriverAssignmentAsset,
  DriverAssignmentDetails,
  DriverAssignmentHistoryItem,
  DriverAssignmentDriver,
} from "../domain";
import type {
  AssignableAssetDto,
  AssignableDriverDto,
  DriverAssignmentDto,
  DriverAssignmentHistoryItemDto,
  DriverAssignmentListItemDto,
} from "./driverAssignmentDtos";

export function driverFromDto(dto: AssignableDriverDto): DriverAssignmentDriver {
  return {
    id: dto.id,
    username: dto.username,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    // The API sends no picture; the UI falls back to the avatar icon.
    avatarUrl: null,
  };
}

export function assetFromDto(dto: AssignableAssetDto): DriverAssignmentAsset {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    code: dto.code,
    branch: {
      id: dto.branch.id,
      nameEn: dto.branch.nameEn,
      nameAr: dto.branch.nameAr,
    },
  };
}

/** One active assignment = one asset: the API returns the pair, the
 *  details screen lists the driver's asset(s). */
export function driverAssignmentDetailsFromDto(
  dto: DriverAssignmentListItemDto,
): DriverAssignmentDetails {
  return {
    id: dto.id,
    driver: driverFromDto(dto.driver),
    assets: [
      {
        assignmentId: dto.id,
        asset: assetFromDto(dto.asset),
        assignedAt: dto.assignedAt,
      },
    ],
  };
}

/** Create's full row and the list's lean one map to the same domain type. */
export function driverAssignmentFromDto(
  dto: DriverAssignmentDto | DriverAssignmentListItemDto,
): DriverAssignment {
  return {
    id: dto.id,
    driver: driverFromDto(dto.driver),
    asset: assetFromDto(dto.asset),
    assignedAt: dto.assignedAt,
  };
}

export function driverAssignmentHistoryItemFromDto(
  dto: DriverAssignmentHistoryItemDto,
): DriverAssignmentHistoryItem {
  return {
    id: dto.id,
    driver: {
      id: dto.driverId,
      nameEn: dto.driverNameEn,
      nameAr: dto.driverNameAr,
      avatarUrl: null,
    },
    asset: {
      id: dto.assetId,
      nameEn: dto.assetNameEn,
      nameAr: dto.assetNameAr,
    },
    action: dto.action,
    assignedAt: dto.assignedAt,
    actionAt: dto.actionAt,
  };
}
